import { Component, OnInit } from '@angular/core';
import { BaseCommonComponent, UserService, BaseDataService, ModalService, LoaderService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-zarada-po-menjacnici',
  templateUrl: './zarada-po-menjacnici.component.html'
})
export class ZaradaPoMenjacniciComponent
extends BaseCommonComponent
implements OnInit {

  Config={}
  mainItems=[]

  baseFormGroup:FormGroup=new FormGroup({
    DatumOd:new FormControl()
    ,DatumDo:new FormControl()
    ,Donos: new FormControl()
  })

  get fc() { return this.baseFormGroup.controls; }
  submitted: boolean = false;
  ID: number;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected loaderService: LoaderService
  ) {
    super(activatedRoute, userService, baseDataService, translateService, modalService, toastrService, loaderService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("DatumOd", Validators.required, 'required', 'ZARADAPOMENJACNICI.DATUMOD.VALIDATION.REQUIRED');
    this.addValidatorToFc("DatumDo", Validators.required, 'required', 'ZARADAPOMENJACNICI.DATUMDO.VALIDATION.REQUIRED');
    this.baseFormGroup.patchValue({Donos: false});
    this.baseFormGroup.get('Donos').updateValueAndValidity();
  }

  OnModelDataLoaded(){
    super.OnModelDataLoaded();
    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      Height: '100w',
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel
    }

  }

 

}
